import * as React from 'react'
import { useAppSelector } from '../../../../../reducers'

interface UseDisplayOptionsOutput {
    chains: { value: number; id: number; name: string }[];
}

function useDisplayOptions(): UseDisplayOptionsOutput {
    const chains = useAppSelector((state) => state.chains.chains)
    
    return React.useMemo(() => {
        const displayChains = chains.map((chain) => {
            return {
                ...chain,
                value: chain.id,
            }
        })

        return { chains: displayChains }
    }, [chains])
}

export default useDisplayOptions
